<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-clipboard-list"
      texto-titulo="Listado de listas"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList url="/listas" :fields="fields" :rowClick="mostrarOpciones" ref="datatable"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import Swal from "sweetalert2";
import axios from "axios";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarMarcas",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      marcas: [],
      fields: [
        {
          name: "descripcion",
          label: "",
          type: "title",
          class: "text-focus",
          append: '-'
        },
        {
            name: 'porcentaje',
            label:'',
            type: 'title',
            class:'text-alternate',
            append: '%'
        }
      ],
      loading: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    mostrarOpciones(lista) {
        this.$router.push({name:'EditarLista', params:{id:lista.id}})
    //   Swal.fire({
    //     title: marca.descripcion,
    //     showCancelButton: true,
    //     confirmButtonText: "Editar",
    //     cancelButtonText: "Eliminar",
    //     confirmButtonColor: "#f7b924",
    //     cancelButtonColor: "#d33",
    //     reverseButtons: true
    //   }).then(result => {
    //     if (result.value) {
    //     } else if (
    //       /* Read more about handling dismissals below */
    //       result.dismiss === Swal.DismissReason.cancel
    //     ) {
    //       this.eliminarMarca(marca)
    //     }
    //   });
    },
    eliminarMarca(marca) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${marca.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/marcas/" + marca.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.marca.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              this.$refs.datatable.update();
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>